export abstract class Handler {
  private _enabled: boolean;

  get enabled(): boolean {
    return this._enabled;
  }

  public enable(): this {
    if (!this._enabled) {
      this._enabled = true;
      this.addHooks();
    }

    return this;
  }

  public disable(): this {
    if (this._enabled) {
      this._enabled = false;
      this.removeHooks();
    }

    return this;
  }

  protected abstract addHooks(): void;
  protected abstract removeHooks(): void;
}
